<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <!-- <div class="page_title">Privacy Policy</div> -->
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Privacy Policy</h1>
          <p class="auth-subtext">Read carefully</p>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
        </div>
      </div>
      <div>
        Last updated: February 20, 2024<br /><br />
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law protects
        You.<br /><br />
        We use Your Personal data to provide and improve the Service. By using the
        Service, You agree to the collection and use of information in accordance
        with this Privacy Policy.<br /><br />
        <h3 class="title">Interpretation and Definitions</h3>
        <h4 class="sub_title">Interpretation</h4>
        <p>
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions shall
          have the same meaning regardless of whether they appear in singular or
          in plural.
        </p>
        <h4 class="sub_title">Definitions</h4>
        <p>
          For the purposes of this Privacy Policy:
        </p>
        <ul class="no_markers">
          <li>
            <b>Account</b> means a unique account created for You to access our
            Service or parts of our Service. Affiliate means an entity that controls,
            is controlled by or is under common control with a party, where "control"
            means ownership of 50% or more of the shares, equity interest or other
            securities entitled to vote for election of directors or other managing
            authority. Application refers to Locumate, the software program provided by the Company.
          </li>
          <li>
            <b>Company</b> (referred to as either "the Company", "We", "Us" or
            "Our" in this Agreement) refers to Locumate Australia Pty Ltd, 5a
            Hartnett Cl, Mulgrave VIC 3170.
          </li>
          <li><b>Country</b> refers to: Victoria, Australia.</li>
          <li>
            <b>Device</b> means any device that can access the Service such as a
            computer, a cellphone or a digital tablet.
          </li>
          <li>
            <b>Personal Data</b> is any information that relates to an identified
            or identifiable individual.
          </li>
          <li><b>Service</b> refers to the Application.</li>
          <li>
            <b>Service Provider</b> means any natural or legal person who
            processes the data on behalf of the Company. It refers to third-party
            companies or individuals employed by the Company to facilitate the
            Service, to provide the Service on behalf of the Company, to perform
            services related to the Service or to assist the Company in analyzing
            how the Service is used.
          </li>
          <li>
            <b>Usage Data</b> refers to data collected automatically, either
            generated by the use of the Service or from the Service infrastructure
            itself (for example, the duration of a page visit).
          </li>
          <li>
            <b>You</b> means the individual accessing or using the Service, or the
            company, or other legal entity on behalf of which such individual is
            accessing or using the Service, as applicable.
          </li>
        </ul>
        <h3 class="title">Collecting and Using Your Personal Data</h3>
        <h4 class="sub_title">Types of Data Collected</h4>
        <h5 class="sub_title">Personal Data</h5>
        <p>
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but is
          not limited to:
        </p>
        <ul>
          <li>
            Email address
          </li>
          <li>
            First name and last name
          </li>
          <li>
            Phone number
          </li>
          <li>
            Address, State, Province, ZIP/Postal code, City
          </li>
          <li>
            Bank account information in order to pay for products and/or services
            within the Service
          </li>
          <li>
            Usage Data
          </li>
        </ul>
        <p>
          When You pay for a product and/or a service via bank transfer, We may
          ask You to provide information to facilitate this transaction and to
          verify Your identity. Such information may include, without limitation:
        </p>
        <ul>
          <li>
            Date of birth
          </li>
          <li>
            Passport or National ID card
          </li>
          <li>
            Bank card statement
          </li>
          <li>
            Other information linking You to an address
          </li>
        </ul>
        <h5 class="sub_title">Usage Data</h5>
        <p>
          Usage Data is collected automatically when using the Service.<br />
          Usage Data may include information such as Your Device's Internet
          Protocol address (e.g. IP address), browser type, browser version, the
          pages of our Service that You visit, the time and date of Your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.<br />
          When You access the Service by or through a mobile device, We may
          collect certain information automatically, including, but not limited
          to, the type of mobile device You use, Your mobile device unique ID, the
          IP address of Your mobile device, Your mobile operating system, the type
          of mobile Internet browser You use, unique device identifiers and other
          diagnostic data.<br />
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a mobile
          device.
        </p>
        <h5 class="sub_title">Information Collected while Using the Application</h5>
        <p>
          While using Our Application, in order to provide features of Our Application,
          We may collect, with Your prior permission:
        </p>
        <ul>
          <li>
            Pictures and other information from your Device's camera and photo library
          </li>
        </ul>
        <p>
          We use this information to provide features of Our Service, to improve and
          customize Our Service. The information may be uploaded to the Company's servers
          and/or a Service Provider's server or it may be simply stored on Your device.
          You can enable or disable access to this information at any time, through Your
          Device settings.
        </p>
        <p>
          Use of Your Personal Data
        </p>
        <p>
          The Company may use Personal Data for the following purposes:
        </p>
        <ul class="no_markers">
          <li>
            <b>To provide and maintain our Service,</b> including to monitor the
            usage of our Service.
          </li>
          <li>
            <b>To manage Your Account:</b> to manage Your registration as a user
            of the Service. The Personal Data You provide can give You access to
            different functionalities of the Service that are available to You as
            a registered user.
          </li>
          <li>
            <b>For the performance of a contract:</b> the development, compliance
            and undertaking of the purchase contract for the products, items or
            services You have purchased or of any other contract with Us through
            the Service.
          </li>
          <li>
            <b>To contact You:</b> To contact You by email, telephone calls, SMS,
            or other equivalent forms of electronic communication, such as a
            mobile application's push notifications regarding updates or
            informative communications related to the functionalities, products or
            contracted services, including the security updates, when necessary or
            reasonable for their implementation.
          </li>
          <li>
            <b>To provide You</b> with news, special offers and general
            information about other goods, services and events which we offer that
            are similar to those that you have already purchased or enquired about
            unless You have opted not to receive such information.
          </li>
          <li>
            <b>To manage Your requests:</b> To attend and manage Your requests to
            Us.
          </li>
          <li>
            <b>For business transfers:</b> We may use Your information to evaluate
            or conduct a merger, divestiture, restructuring, reorganization,
            dissolution, or other sale or transfer of some or all of Our assets,
            whether as a going concern or as part of bankruptcy, liquidation, or
            similar proceeding, in which Personal Data held by Us about our
            Service users is among the assets transferred.
          </li>
          <li>
            <b>For other purposes:</b> We may use Your information for other
            purposes, such as data analysis, identifying usage trends, determining
            the effectiveness of our promotional campaigns and to evaluate and
            improve our Service, products, services, marketing and your
            experience.
          </li>
        </ul>
        <p>
          We may share Your personal information in the following situations:
        </p>
        <ul>
          <li>
            <b> With Service Providers:</b> We may share Your personal information
            with Service Providers to monitor and analyze the use of our Service,
            for payment processing, to contact You.
          </li>
          <li>
            <b>For business transfers:</b> We may share or transfer Your personal
            information in connection with, or during negotiations of, any merger,
            sale of Company assets, financing, or acquisition of all or a portion
            of Our business to another company.
          </li>
          <li>
            <b>With Affiliates:</b> We may share Your information with Our
            affiliates, in which case we will require those affiliates to honor
            this Privacy Policy. Affiliates include Our parent company and any
            other subsidiaries, joint venture partners or other companies that We
            control or that are under common control with Us.
          </li>
          <li>
            <b>With business partners:</b> We may share Your information with Our
            business partners to offer You certain products, services or
            promotions.
          </li>
          <li>
            <b> With other users:</b> when You share personal information or
            otherwise interact in the public areas with other users, such
            information may be viewed by all users and may be publicly distributed
            outside.
          </li>
          <li>
            <b>With Your consent:</b> We may disclose Your personal information
            for any other purpose with Your consent.
          </li>
        </ul>
        <h4 class="sub_title">Retention of Your Personal Data</h4>
        <p>
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply with
          our legal obligations (for example, if we are required to retain your
          data to comply with applicable laws), resolve disputes, and enforce our
          legal agreements and policies.<br />
          The Company will also retain Usage Data for internal analysis purposes.
          Usage Data is generally retained for a shorter period of time, except
          when this data is used to strengthen the security or to improve the
          functionality of Our Service, or We are legally obligated to retain this
          data for longer time periods.
        </p>
        <h4 class="sub_title">Transfer of Your Personal Data</h4>
        <p>
          Your information, including Personal Data, is processed at the Company's
          operating offices and in any other places where the parties involved in
          the processing are located. It means that this information may be
          transferred to — and maintained on — computers located outside of Your
          state, province, country or other governmental jurisdiction where the
          data protection laws may differ than those from Your jurisdiction.<br />
          Your consent to this Privacy Policy followed by Your submission of such
          information represents Your agreement to that transfer.<br />
          The Company will take all steps reasonably necessary to ensure that Your
          data is treated securely and in accordance with this Privacy Policy and
          no transfer of Your Personal Data will take place to an organization or
          a country unless there are adequate controls in place including the
          security of Your data and other personal information.
        </p>
        <h4 class="sub_title">Delete Your Personal Data</h4>
        <p>You have the right to delete or request that We assist
          in deleting the Personal Data that We have collected about You.</p>
        <p>Our Service may give You the ability to delete certain
          information about You from within the Service.</p>
        <p>You may update, amend, or delete Your information at any
          time by signing in to Your Account, if you have one, and visiting the account
          settings section that allows you to manage Your personal information. You may
          also contact Us to request access to, correct, or delete any personal
          information that You have provided to Us.</p>
        <p>Please note, however, that We may need to retain certain
          information when we have a legal obligation or lawful basis to do so.</p>
        <h4 class="sub_title">Disclosure of Your Personal Data</h4>
        <h5 class="sub_title">Business Transactions</h5>
        <p>
          If the Company is involved in a merger, acquisition or asset sale, Your
          Personal Data may be transferred. We will provide notice before Your
          Personal Data is transferred and becomes subject to a different Privacy
          Policy.
        </p>
        <h5 class="sub_title">Law enforcement</h5>
        <p>
          Under certain circumstances, the Company may be required to disclose
          Your Personal Data if required to do so by law or in response to valid
          requests by public authorities (e.g. a court or a government agency).
        </p>
        <h5 class="sub_title">Other legal requirements</h5>
        <p>
          The Company may disclose Your Personal Data in the good faith belief
          that such action is necessary to:
        </p>
        <ul>
          <li>
            Comply with a legal obligation
          </li>
          <li>
            Protect and defend the rights or property of the Company
          </li>
          <li>
            Prevent or investigate possible wrongdoing in connection with the
            Service
          </li>
          <li>
            Protect the personal safety of Users of the Service or the public
          </li>
          <li>
            Protect against legal liability
          </li>
        </ul>
        <h4 class="sub_title">Security of Your Personal Data</h4>
        <p>
          The security of Your Personal Data is important to Us, but remember that
          no method of transmission over the Internet, or method of electronic
          storage is 100% secure. While We strive to use commercially acceptable
          means to protect Your Personal Data, We cannot guarantee its absolute
          security.
        </p>
        <h3 class="title">
          Detailed Information on the Processing of Your Personal Data
        </h3>
        <p>
          The Service Providers We use may have access to Your Personal Data.
          These third-party vendors collect, store, use, process and transfer
          information about Your activity on Our Service in accordance with their
          Privacy Policies.
        </p>
        <h4 class="sub_title">Analytics</h4>
        <p>We may use third-party Service providers to monitor and analyze the use of our Service.</p>
        <ul class="no_markers">
          <li>
            <b>Google Analytics</b>
          </li>
          <li>
            Google Analytics is a web analytics service offered by Google that tracks and reports
            website traffic. Google uses the data collected to track and monitor the use of our Service.
            This data is shared with other Google services. Google may use the collected data to
            contextualize and personalize the ads of its own advertising network.
          </li>
          <li>
            You may opt-out of certain Google Analytics features through your mobile device settings,
            such as your device advertising settings or by following the instructions provided by
            Google in their Privacy Policy: https://policies.google.com/privacy
          </li>
          <li>
            For more information on the privacy practices of Google, please visit the Google
            Privacy & Terms web page: https://policies.google.com/privacy
          </li>
        </ul>
        <h4 class="sub_title">Email Marketing</h4>
        <p>
          We may use Your Personal Data to contact You with newsletters, marketing
          or promotional materials and other information that may be of interest
          to You. You may opt-out of receiving any, or all, of these
          communications from Us by following the unsubscribe link or instructions
          provided in any email We send or by contacting Us.<br />
          We may use Email Marketing Service Providers to manage and send emails
          to You.
        </p>
        <ul class="no_markers">
          <li>
            <b>Mailchimp</b>
          </li>
          <li>
            Mailchimp is an email marketing sending service provided by The Rocket Science Group LLC.
            For more information on the privacy practices of Mailchimp, please visit their Privacy
            policy: https://mailchimp.com/legal/privacy/
          </li>
          <li>
            <b>Klaviyo</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.klaviyo.com/legal/privacy
          </li>
          <li>
            <b>Salesforce</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.salesforce.com/au/company/privacy/
          </li>
          <li>
            <b>Postmark</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://postmarkapp.com/privacy-policy
          </li>
          <li>
            <b>Pusher</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://bird.com/en/legal/privacy
          </li>
          <li>
            <b>Airwallex</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.airwallex.com/au/terms/privacy-policy#scope-of-policy
          </li>
        </ul>
        <h4 class="sub_title">Payments</h4>
        <p>
          We may provide paid products and/or services within the Service. In that
          case, we may use third-party services for payment processing (e.g.
          payment processors).<br />
          We will not store or collect Your payment card details. That information
          is provided directly to Our third-party payment processors whose use of
          Your personal information is governed by their Privacy Policy. These
          payment processors adhere to the standards set by PCI-DSS as managed by
          the PCI Security Standards Council, which is a joint effort of brands
          like Visa, Mastercard, American Express and Discover. PCI-DSS
          requirements help ensure the secure handling of payment information.
        </p>
        <p>
          When You use Our Service to pay a product and/or service via bank
          transfer, We may ask You to provide information to facilitate this
          transaction and to verify Your identity.
        </p>
        <h4 class="sub_title">Usage, Performance and Miscellaneous</h4>
        <p>
          We may use third-party Service Providers to maintain and improve our Service.
        </p>
        <ul class="no_markers">
          <li>
            <b>Google Places</b>
          </li>
          <li>
            Google Places is a service that returns information about places using
            HTTP requests. It is operated by Google
          </li>
          <li>
            Google Places service may collect information from You and from Your
            Device for security purposes.
          </li>
          <li>
            The information gathered by Google Places is held in accordance with
            the Privacy Policy of Google:
            <a
              href="https://www.google.com/intl/en/policies/privacy/">https://www.google.com/intl/en/policies/privacy/</a>
          </li>
          <li>
            <b>Amazon Web Services (AWS)</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://aws.amazon.com/privacy/
          </li>
          <li>
            <b>Cloudflare</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.cloudflare.com/en-gb/trust-hub/australia-privacy-act/
          </li>
          <li>
            <b>HelpScout</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.helpscout.com/company/legal/privacy/
          </li>
          <li>
            <b>Twilio</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.twilio.com/en-us/legal/privacy
          </li>
          <li>
            <b>__Xero __</b>
          </li>
          <li>
            Their Privacy Policy can be viewed at https://www.xero.com/au/legal/privacy/
          </li>
        </ul>
        <h4 class="sub_title">Children's Privacy</h4>
        <p>
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from anyone under
          the age of 13. If You are a parent or guardian and You are aware that
          Your child has provided Us with Personal Data, please contact Us. If We
          become aware that We have collected Personal Data from anyone under the
          age of 13 without verification of parental consent, We take steps to
          remove that information from Our servers.<br />
          If We need to rely on consent as a legal basis for processing Your
          information and Your country requires consent from a parent, We may
          require Your parent's consent before We collect and use that
          information.
        </p>
        <h4 class="sub_title">Links to Other Websites</h4>
        <p>
          Our Service may contain links to other websites that are not operated by
          Us. If You click on a third party link, You will be directed to that
          third party's site. We strongly advise You to review the Privacy Policy
          of every site You visit.<br />
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </p>
        <h4 class="sub_title">Changes to this Privacy Policy</h4>
        <p>
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page.<br />
          We will let You know via email and/or a prominent notice on Our Service,
          prior to the change becoming effective and update the "Last updated"
          date at the top of this Privacy Policy.<br />
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </p>
        <h3 class="title">Contact Us</h3>
        <p>
          If you have any questions about this Privacy Policy, You can
          contact us:
        </p>
        <ul class="no_markers">
          <li>
            By email: support@locumate.com.au
          </li>
          <li>
            By visiting this page on our website:
            <a href="/">https://locumate.com.au/contact-us/</a>
          </li>
          <li>
            By phone number: (03) 9120 7780
          </li>
          <li>
            By mail: P.O Box 2446 Rowville, VIC 3178, Australia
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import {useStore} from "vuex";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 


import { useRouter, useRoute } from "vue-router";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  directives: {},
  setup() {
    const $router = useRouter();
    const $store = useStore();
    const backPage = $store.getters.getLastPage;

    const $route = useRoute();
    const routeName = $route.name;
    const setPageClassGlobal = inject("setPageClassGlobal");
    const userData = $store.getters.GET_USER_DATA;
    const goBack = () => {
      if (routeName === "privacy_policy2") {
        $router.push({
          name: "auth",
        });
      } else if (routeName ==="privacy_policy_update"){
        $router.push({
          name: "search",
        });

      }
      else {
        if(userData.role === 'job-seeker'){
          if(backPage === '/job-seeker/index'){
                $router.push({
                name: "job_seeker_index",
            });
            }else{
                $router.push({
                name: "profile_job_seeker_setting",
            });
            }
        }else{
        $router.push({
          name: "common_about",
        });
      }
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_privacy_terms_page");
    });

    return {
      goBack,
      routeName,
      userData
    };
  },
};
</script>
